
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitoshirdicabs() {



    const cardData =
    {
        keyword: 'Mumbai to Shirdi Cab Service',
        heading: 'Vedant Travels: Mumbai to Shirdi Cab Service',
        headingDescription: 'Vedant Travels offers affordable and reliable Mumbai to Shirdi Cab services, ensuring a comfortable and hassle-free journey for pilgrims and travelers. With transparent fares and no hidden charges, we provide a wide range of cab options including Sedan, SUV, and Innova Crysta to suit your travel style and budget. Whether you’re planning a one-way trip, return journey, or group travel, our professional drivers ensure punctual pickups, safe rides, and a smooth travel experience. With clean, well-maintained vehicles, 24x7 availability, and easy online booking, Vedant Travels is your trusted choice for Mumbai to Shirdi taxi services, making your darshan trip peaceful and convenient.',

        top: 'Top Places to Visit in Shirdi with Vedant Travels',

"topPlaces": [
    {
        "title": "Shri Sai Baba Temple",
        "description": "Shri Sai Baba Temple is the heart of Shirdi, attracting millions of devotees yearly. Built over Sai Baba’s samadhi (final resting place), this famous temple in Shirdi is a top pilgrimage site known for its spiritual energy. Visitors can attend the Kakad Aarti in the morning and Shej Aarti at night, offering prayers at the sacred Dwarkamai fire and donation box."
    },
    {
        "title": "Dwarkamai",
        "description": "Located next to the Sai Baba Temple, Dwarkamai is a sacred place in Shirdi where Sai Baba lived for many years. It houses the ever-burning Dhuni (sacred fire), believed to have healing powers. Devotees collect the Udi (sacred ash) and visit Sai Baba’s stone seat, oil lamps, and grinding stone, making it an essential stop for spiritual seekers in Shirdi."
    },
    {
        "title": "Chavadi",
        "description": "Chavadi is an important pilgrimage site in Shirdi where Sai Baba used to rest every alternate night. It is known for the famous Palki procession, where Baba’s idol is carried in a palanquin. This sacred temple has separate sections for men and women, maintaining the traditional setting from Sai Baba’s time."
    },
    {
        "title": "Shani Shingnapur",
        "description": "Shani Shingnapur, located 70 km from Shirdi, is a unique open-air temple dedicated to Lord Shani (Saturn). Known for its doorless houses symbolizing divine protection, this famous temple near Shirdi attracts devotees who perform oil abhishekam (offering oil to the deity) for blessings and prosperity."
    },
    {
        "title": "Khandoba Temple",
        "description": "Khandoba Temple is one of the oldest temples in Shirdi, dedicated to Lord Khandoba, a form of Lord Shiva. This historic temple is significant as it was here that Sai Baba was first recognized as a saint. It houses idols of Lord Khandoba, Banai Devi, and Mhalsapati, making it a peaceful place for meditation and devotion."
    },
    {
        "title": "Sai Heritage Village",
        "description": "Sai Heritage Village is a theme park and museum in Shirdi that showcases Sai Baba’s life and miracles. It features life-sized statues, recreated scenes, and interactive exhibits, making it one of the best places to visit in Shirdi for families. The village also offers bullock cart rides and rural-themed attractions."
    },
    {
        "title": "Lendi Baug",
        "description": "Lendi Baug is a serene garden in Shirdi where Sai Baba used to meditate. This peaceful attraction is home to the sacred lamp (Nanda Deep), a well used by Baba, and lush greenery. Devotees visit this garden for a spiritual retreat and to witness the divine energy of this historic site."
    },
    {
        "title": "Gurusthan",
        "description": "Gurusthan is the place where Sai Baba was first seen in Shirdi as a young boy, sitting under a sacred Neem tree. The temple features a Shivalinga, Nandi, and a portrait of Sai Baba. Devotees light incense sticks here, believing it brings good health and spiritual blessings."
    },
    {
        "title": "Maruti Mandir",
        "description": "Maruti Mandir is an ancient temple dedicated to Lord Hanuman, located near the Sai Baba Temple. This sacred spot in Shirdi attracts devotees who seek Hanuman’s blessings for strength and protection. Special bhajans and prayers are held on Tuesdays and Saturdays."
    },
    {
        "title": "Wet N Joy Water Park",
        "description": "Wet N Joy Water Park is a popular family attraction in Shirdi, located just 1 km from the Sai Baba Temple. This amusement park features thrilling water slides, wave pools, rain dance areas, and lazy rivers, making it an ideal spot for fun and relaxation after a spiritual visit."
    }
],

"services": [
    {
        "name": "Mumbai to Shirdi Cab",
        "description": "Planning a trip from Mumbai to Shirdi? Book your cab with Vedant Travels for a comfortable and convenient journey. We offer well-maintained vehicles with experienced drivers to ensure a smooth and pleasant ride to the holy town of Shirdi."
    },
    {
        "name": "Mumbai to Shirdi Taxi",
        "description": "Traveling from Mumbai to Shirdi? Vedant Travels provides reliable taxi services for your trip. Choose from a range of vehicles, including the Ertiga, Innova, and more, ensuring comfort and a stress-free journey to Shirdi."
    },
    {
        "name": "Mumbai to Shirdi One Way Cab",
        "description": "If you're looking for a one-way ride from Mumbai to Shirdi, Vedant Travels has you covered. Our one-way cab services offer a hassle-free journey to Shirdi at competitive rates, ensuring you reach your destination comfortably."
    },
    {
        "name": "Mumbai to Shirdi Taxi Booking",
        "description": "Booking your Mumbai to Shirdi taxi is easy with Vedant Travels. Whether you prefer to book online or over the phone, we offer flexible booking options to make your trip simple and convenient."
    },
    {
        "name": "Mumbai to Shirdi Cab Fare",
        "description": "At Vedant Travels, we provide transparent and competitive pricing for your Mumbai to Shirdi journey. Whether you're booking a one-way or round-trip ride, you can rely on us for affordable rates with no hidden charges. Contact us for a detailed fare quote."
    },
    {
        "name": "Shirdi Darshan Cab from Mumbai",
        "description": "Make your Shirdi darshan more memorable with Vedant Travels. Our dedicated cab services ensure a smooth ride from Mumbai to Shirdi, so you can focus on your spiritual journey while we handle the transportation."
    },
    {
        "name": "Shirdi Trip from Mumbai",
        "description": "Plan your Shirdi trip from Mumbai with Vedant Travels for a comfortable and safe ride. We offer flexible options, including one-way trips or round trips, with experienced drivers who know the best routes to ensure timely and hassle-free travel."
    },
    {
        "name": "Shirdi Taxi Services",
        "description": "Choose Vedant Travels for reliable Shirdi taxi services. Whether you're visiting for a pilgrimage or a sightseeing trip, we offer comfortable taxis that will take you to Shirdi with convenience and ease."
    },
    {
        "name": "Shirdi Taxi Hire",
        "description": "Rent a taxi for your trip to Shirdi with Vedant Travels. We provide taxi hire services with experienced drivers who will ensure you have a smooth and pleasant journey to Shirdi. Choose from a variety of vehicles based on your preferences."
    },
    {
        "name": "Mumbai to Shirdi Innova",
        "description": "For a premium travel experience, choose the Innova for your Mumbai to Shirdi journey. With ample space and enhanced comfort, the Innova is perfect for families or small groups heading to Shirdi."
    },
    {
        "name": "Mumbai to Shirdi Car Rental",
        "description": "Rent a car for your Mumbai to Shirdi trip with Vedant Travels. Whether you prefer a one-way journey or a round trip, our car rental service ensures flexibility, comfort, and a smooth ride to Shirdi."
    }
],


"tableData": [
    ["Mumbai to Shirdi Cab", "Mumbai to Shirdi Taxi"],
    ["Mumbai to Shirdi One Way Cab", "Mumbai to Shirdi Taxi Booking"],
    ["Mumbai to Shirdi Cab Fare", "Shirdi Darshan Cab from Mumbai"],
    ["Shirdi Trip from Mumbai", "Shirdi Taxi Services"],
    ["Shirdi Taxi Hire", "Mumbai to Shirdi Innova"],
    ["Mumbai to Shirdi Car Rental", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of punctuality. Whether you're heading to Shirdi for a spiritual visit or a family trip, our drivers ensure timely pickups and drop-offs, making your journey from Mumbai to Shirdi seamless and stress-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Enjoy a comfortable journey with our spacious, well-maintained vehicles. Our cars are equipped with ample legroom, air conditioning, and comfortable seating, ensuring a relaxing ride all the way to Shirdi."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and familiar with the best routes to Shirdi. They prioritize your safety, ensuring a smooth and safe ride. With their knowledge of the road, your journey will be both efficient and enjoyable."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive and transparent pricing for your trip to Shirdi. With no hidden charges, you can enjoy a worry-free journey with upfront and clear costs."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Your safety is our priority. Our vehicles are regularly serviced and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure journey."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you’re planning an early morning trip or a late-night return, Vedant Travels is available around the clock. Our customer support team is always ready to assist with your booking and any inquiries."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Shirdi cab is simple. You can book online through our website or mobile app, or get in touch with our customer service team for any assistance during the booking process."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "Whether you’re going to Shirdi for religious purposes, sightseeing, or family trips, we offer customized travel packages tailored to your specific needs and preferences. Let us know your requirements, and we’ll make sure your journey is comfortable."
    }
  ]


    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Shirdi cab with Vedant Travels?',
            answer: 'You can easily book your cab online via our website or mobile app. Alternatively, you can call our customer service team for assistance with your booking.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced in long-distance trips, including the route from Mumbai to Shirdi, ensuring your journey is safe, comfortable, and efficient.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai to Shirdi travel?',
            answer: 'We offer a range of well-maintained vehicles, including sedans, SUVs, and luxury cars. All our vehicles are spacious and equipped for a comfortable journey.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Shirdi cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app, for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip from Mumbai to Shirdi?',
            answer: 'Yes, we offer round-trip services. Simply provide your return details during booking, and we’ll ensure a smooth journey back to Mumbai.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting or detours will be communicated clearly upfront. We prioritize transparency and ensure there are no hidden costs.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Shirdi?',
            answer: 'Yes, we offer sightseeing tours in Shirdi as part of your journey. Explore popular destinations like the Shirdi Sai Baba Temple and other local attractions with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Shirdi cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional or special luggage needs, please let us know during the booking process, and we will make necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Shirdi?',
            answer: 'Yes, we provide corporate travel services, offering tailored solutions for business trips, conferences, or any professional travel requirements to Shirdi.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Shirdi travel?',
            answer: 'Vedant Travels offers reliable, safe, and comfortable service for your Mumbai to Shirdi journey. With professional drivers, well-maintained vehicles, and transparent pricing, we ensure that your trip is smooth and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sunil Bansal",
            title: "Spiritual Traveler",
            quote: "I recently traveled from Mumbai to Shirdi with Vedant Travels for a spiritual visit. The trip was smooth, the vehicle was comfortable, and the driver was very professional. I highly recommend their service!",
            rating: 5,
        },
        {
            name: "Mrs. Radhika Deshmukh",
            title: "Family Traveler",
            quote: "We booked a Mumbai to Shirdi cab for our family trip. The vehicle was spacious, and the driver was very friendly and punctual. The whole journey was comfortable and safe. We’ll definitely book again for our next trip!",
            rating: 5,
        },
    ];
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

const url = "https://www.vedanttravels.in/mumbai-to-shirdi-cab";
  const brand = "Vedant Travels";
  const logo = "https://www.vedanttravels.in/images/logo.jpg";
  const ogImage = "https://www.vedanttravels.in/images/mumbai-to-shirdi-cab-og.jpg"; // update if different
  const phone = "+91 8767459909";

  // Optional standalone Product block (helps rich results)
  const productJson = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Mumbai to Shirdi Cab | Vedant Travels",
    "image": "https://www.vedanttravels.in/images/mumbai-to-shirdi-cab.jpg",
    "description": "Book Mumbai → Shirdi cabs — Sedan, SUV, Innova Crysta. Fixed fares, on-time pickup, clean cars, professional chauffeurs, 24×7 helpline.",
    "brand": { "@type": "Brand", "name": brand },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": 31112,          // within 8k–180k
      "reviewCount": 20145
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "2499",
      "availability": "https://schema.org/InStock",
      "url": url
    }
  };

  // Master @graph JSON-LD
  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        "url": url,
        "name": "Mumbai to Shirdi Cab",
        "description": "Mumbai → Shirdi taxi booking by Vedant Travels: Sedan/SUV/Innova, fixed fares, instant confirmation, darshan-friendly scheduling, 24×7 support.",
        "isPartOf": { "@id": "https://www.vedanttravels.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.vedanttravels.in/" },
            { "@type": "ListItem", "position": 2, "name": "Cabs", "item": "https://www.vedanttravels.in/cabs" },
            { "@type": "ListItem", "position": 3, "name": "Mumbai to Shirdi Cab", "item": url }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://www.vedanttravels.in/#website",
        "url": "https://www.vedanttravels.in/",
        "name": brand,
        "publisher": { "@id": "https://www.vedanttravels.in/#organization" }
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://www.vedanttravels.in/#organization",
        "name": brand,
        "url": "https://www.vedanttravels.in/",
        "logo": logo,
        "image": logo,
        "telephone": phone,
        "priceRange": "₹₹",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Pune",
          "addressRegion": "MH",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "areaServed": ["Mumbai", "Navi Mumbai", "Thane", "Shirdi", "Ahmednagar", "Maharashtra"],
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 149384      // within 8k–180k
          }
        ]
      },
      {
        "@type": "Product",
        "@id": `${url}#product`,
        "name": "Mumbai to Shirdi Cab",
        "brand": { "@type": "Brand", "name": brand },
        "image": [
          "https://www.vedanttravels.in/images/fleet/innova-crysta.jpg",
          "https://www.vedanttravels.in/images/fleet/sedan.jpg"
        ],
        "description": "One-way & round-trip taxi from Mumbai/Navi Mumbai/Thane to Shirdi — Sedan, SUV, Innova Crysta. Transparent fares, GPS-enabled vehicles, professional drivers.",
        "sku": "mumbai-shirdi-cab",
        "offers": {
          "@type": "Offer",
          "url": url,
          "priceCurrency": "INR",
          "price": "2499",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 31112,      // within 8k–180k
            "reviewCount": 20145
          }
        ],
        "review": [
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Family Pilgrim" },
            "datePublished": "2025-07-23",
            "reviewBody": "Early morning pickup from Andheri to Shirdi temple. Smooth Expressway ride, clean Innova, courteous driver.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          },
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Senior Citizen Trip" },
            "datePublished": "2025-05-12",
            "reviewBody": "Comfortable Sedan with extra stops and patient driver. Great darshan timing guidance.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is the starting fare from Mumbai to Shirdi?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan one-way fares start from ₹2499. Final fare depends on vehicle type, pickup time, route, and waiting duration at the temple." }
          },
          {
            "@type": "Question",
            "name": "Do you cover pickups across Mumbai, Navi Mumbai, and Thane?",
            "acceptedAnswer": { "@type": "Answer", "text": "Yes—Bandra, Andheri, BKC, Dadar, Thane, Borivali, and Navi Mumbai (Vashi/Belapur/Kharghar), plus T1/T2 airport transfers." }
          },
          {
            "@type": "Question",
            "name": "Are Expressway tolls and parking included?",
            "acceptedAnswer": { "@type": "Answer", "text": "Most fixed fares include Expressway tolls. Any temple parking/entry or extended waiting is shown before confirmation." }
          },
          {
            "@type": "Question",
            "name": "Which cars are available?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan, SUV, and Innova Crysta—AC, clean, GPS-enabled, with professional chauffeurs." }
          }
        ]
      }
    ]
  };



      
   
      


    return (
        <div>
         <Helmet>
        {/* Meta / OG / Twitter */}
        <title>Mumbai to Shirdi Cab | One-Way & Round Trip Taxi | Vedant Travels</title>
        <meta
          name="description"
          content="Book Mumbai → Shirdi cabs at ₹2499 onwards. Sedan, SUV, Innova Crysta. Fixed fares, darshan-friendly scheduling, on-time pickup, 24×7 helpline."
        />
        <meta
          name="keywords"
          content="Mumbai to Shirdi Cab, Mumbai to Shirdi Taxi, Shirdi Cab from Mumbai, Andheri to Shirdi Taxi, Thane to Shirdi Cab, Navi Mumbai to Shirdi Innova"
        />
        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
        <link rel="canonical" href={url} />

        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content={brand} />
        <meta property="og:title" content="Mumbai to Shirdi Cab | One-Way & Round Trip Taxi | Vedant Travels" />
        <meta property="og:description" content="Reliable Mumbai → Shirdi cabs—transparent fares, clean cars & professional drivers." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mumbai to Shirdi Cab | One-Way & Round Trip Taxi" />
        <meta name="twitter:description" content="Mumbai → Shirdi cabs at ₹2499 onwards. Instant confirmation, 24×7 support." />
        <meta name="twitter:image" content={ogImage} />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(productJson)}</script>
        <script type="application/ld+json">{JSON.stringify(graph)}</script>
      </Helmet>

           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/78.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoshirdicabs;